import { elevation, themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import ReactPlayer from "react-player";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    videoUrl: string;
    extendedStyles?: VideoThumbnailStyles;
}

type Props = OwnProps;

export interface VideoThumbnailStyles {
    wrapper?: InjectableCss;
    playIcon?: InjectableCss;
}

export const videoThumbnailStyles: VideoThumbnailStyles = {
    wrapper: {
        css: css`
            position: relative;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            border-radius: 8px;
            cursor: pointer;

            > div {
                &:focus-visible {
                    outline: none;
                    border: 1px solid ${themeBackgrounds.white};
                    box-shadow: ${elevation.focus};
                }
            }
        `,
    },
    playIcon: {
        css: css`
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 48px;
            color: white;
            background-color: rgba(0, 0, 0, 0.6);
            border-radius: 50%;
            padding: 12px;
        `,
    },
};

const ProductDetailsVideoPreview = ({ videoUrl, extendedStyles }: Props) => {
    const [styles] = useState(() => mergeToNew(videoThumbnailStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.wrapper} tabIndex={0}>
            <ReactPlayer controls width="100%" height="100%" url={videoUrl} />
            <a
                href="#"
                onClick={e => {
                    e.preventDefault();
                }}
            >
                {" "}
            </a>
        </StyledWrapper>
    );
};

export default connect()(ProductDetailsVideoPreview);
